import React from "react";

const MessageTime = ({ time }: { time: Date }) => (
  <p className="text-sm text-textsecondary pb-2">
    {time.toLocaleString("ru-RU")}
  </p>
);

export default MessageTime;